import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.scss';
const root = document.getElementById('root');
if (!root)
    throw new Error('Nexus Analytics requires a #root element.');
createRoot(root).render(_jsx(StrictMode, { children: _jsx(App, {}) }));
